export default __webpack_public_path__ + "static/media/404.ba55511a.svg";